import { useQuery } from '@tcs/common/hooks/useQuery';
import { FeeDetails } from '@tcs/client-portal-api/types/Fees';

interface Props {
  loading: boolean;
  data?: FeeDetails[][];
}

export const useFees = (options?: { enabled: boolean }): Props => {
  const { data, isLoading: loading } = useQuery<FeeDetails[][], Error>(
    `/accounts/multiple/fees`,
    options
  );
  return {
    loading,
    data,
  };
};

export default useFees;
